<template>
  <div>
    <h1 class="subtitle is-4 has-text-centered">
      Interface tokens on {{ currentChain.name }}
    </h1>
<div class="table-container">
    <table class="table is-fullwidth   table is-hoverable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Symbol</th>
          <th>Address</th>
          <th>Chain ID</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(t, key) in wrappedTokens"
          :key="key"
        >
          <td>{{ t.name }}</td>
          <td>{{ t.symbol }}</td>
          <td>{{ t.wrappedToken }}</td>
          <td>{{ t.sourceChain }}</td>
        </tr>
      </tbody>
    </table>
</div>

    <div class="pagination is-centered">
      <ul class="pagination-list">
        <li>
          <a
            @click="prevPage"
            :class="{ 'is-disabled': currentPage === 1 }"
            class="pagination-previous"
          >&laquo; Previous</a>
        </li>
        
        <li>
          <span class="pagination-ellipsis">
             {{ currentPage }} of {{ totalPages }}
          </span>
        </li>

        <li>
          <a
            @click="nextPage"
            :class="{ 'is-disabled': currentPage === totalPages }"
            class="pagination-next"
          >Next &raquo;</a>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import loader from '@/mixins/loader'
import utilities from '@/mixins/utilities'
import { getChainData } from '@/constants/chains'

export default {
  mixins: [
    loader,
    utilities
  ],
  data () {
    return {
      currentChain: {},
      selectedToken: 0,
      name: '',
      symbol: '',
      sourceChainId: '',
      sourceTokens: [],
      wrappedTokens: [],
      currentPage: 1, //
      tokensPerPage: 30 //
    }
  },
  computed: {
    ...mapState([
      'chainId'
    ])
  },
  watch: {
    chainId: {
      handler: 'fetchPageData',
      immediate: true
    },
    wrappedTokens: {
      handler: 'updateTotalPages',
      immediate: true
    }
  },
  methods: {
    async fetchPageData () {
      this.execWithLoader(async () => {
        this.currentChain = getChainData(this.chainId)
        this.wrappedTokens = this.$store.state.wrappedTokens
      }, 'Error fetching wrapped tokens')
    },
    updateTotalPages () {
      this.totalPages = Math.ceil(this.wrappedTokens.length / this.tokensPerPage)
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1
      }
    }
  }
}
</script>
